import React from 'react';

// To use this component, make sure you have Bootstrap 5 and Font Awesome included in your project's public/index.html file.
// <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">
// <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />

// Custom styles for the gradient text and other enhancements
const styles = `
  body {
    background-color: #f7f8fc; /* A softer, more modern background color */
    color: #495057; /* A slightly softer text color */
  }
  .gradient-text {
    background: linear-gradient(90deg, #f96b2c, #ff4d4d);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    font-weight: 700;
  }
  .policy-container {
      background-color: #ffffff;
      border-radius: 20px;
      box-shadow: 0 8px 30px rgba(0,0,0,0.05);
  }
  .policy-icon-bg {
    font-size: 1.5rem;
    width: 50px;
    height: 50px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: #fff;
    background: linear-gradient(135deg, #f96b2c, #ff4d4d);
    box-shadow: 0 4px 15px rgba(252, 107, 44, 0.4);
  }
  .section-icon {
      color: #f96b2c;
  }
  .list-group-item {
      border: none;
      padding-left: 0;
      background-color: transparent;
  }
  .list-group-item .fa-check-circle {
      color: #f96b2c; /* Matching the brand color */
  }
  .contact-box {
      background-color: #fffaf7;
      border: 1px dashed #fde0d3;
  }
`;

const PrivacyPolicy = () => {
  return (
    <>
      <style>{styles}</style>
      <div className="container my-5">
        <div className="text-center mb-5">
          <h1 className="display-4 gradient-text">Privacy Policy</h1>
          <p className="lead text-muted">Your trust is our priority. We are committed to protecting your data.</p>
        </div>

        <div className="row">
          <div className="col-lg-10 mx-auto">
            <div className="policy-container p-4 p-md-5">

              <p className="mb-4 text-secondary">
                This Privacy Policy outlines the manner in which <strong>Booze247.co.uk</strong> ("we," "us," or "our") collects, utilizes, maintains, and discloses information gathered from users (each, a "User") of our website and mobile application. This policy is applicable to the site and all products and services offered by us, especially concerning authentication via Facebook. By using our services, you consent to the terms laid out in this policy.
              </p>

              <hr className="my-5" />

              {/* Section: Information We Collect */}
              <h2 className="h4 fw-bold mb-4">
                <i className="fas fa-database me-3 section-icon"></i>1. Information We Collect
              </h2>
              <div className="card border-0 bg-light mb-4">
                  <div className="card-body">
                      <p className="mb-3">When you register or log in using your Facebook account, we request your permission to access certain data. The information we collect includes:</p>
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item"><i className="fas fa-check-circle me-2"></i><strong>Personal Identification Information:</strong> Your full name and email address.</li>
                        <li className="list-group-item"><i className="fas fa-check-circle me-2"></i><strong>Profile Information:</strong> Your Facebook profile picture and a link to your public profile.</li>
                        <li className="list-group-item"><i className="fas fa-check-circle me-2"></i><strong>Usage Data:</strong> We may also collect non-personal information about how you interact with our service, such as pages visited, time spent, and features used.</li>
                      </ul>
                  </div>
              </div>


              {/* Section: How We Use Your Information */}
              <h2 className="h4 fw-bold mt-5 mb-4">
                <i className="fas fa-cogs me-3 section-icon"></i>2. How We Use Your Information
              </h2>
              <div className="card border-0 bg-light mb-4">
                  <div className="card-body">
                      <p className="mb-3">The data we collect serves several purposes to enhance your experience:</p>
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item"><i className="fas fa-check-circle me-2"></i><strong>To Create and Manage Your Account:</strong> To set up a user profile and provide seamless access.</li>
                        <li className="list-group-item"><i className="fas fa-check-circle me-2"></i><strong>To Personalize User Experience:</strong> To tailor content and recommendations to your preferences.</li>
                        <li className="list-group-item"><i className="fas fa-check-circle me-2"></i><strong>To Process Transactions:</strong> To manage orders, payments, and facilitate delivery via our partners.</li>
                        <li className="list-group-item"><i className="fas fa-check-circle me-2"></i><strong>To Improve Our Service:</strong> To analyze usage patterns and gather feedback for service enhancement.</li>
                        <li className="list-group-item"><i className="fas fa-check-circle me-2"></i><strong>To Communicate with You:</strong> To send order confirmations, delivery updates, and promotional materials (with your consent).</li>
                      </ul>
                  </div>
              </div>

              {/* Section: Data Sharing and Disclosure */}
              <h2 className="h4 fw-bold mt-5 mb-4">
                <i className="fas fa-share-alt me-3 section-icon"></i>3. Sharing of Data
              </h2>
              <p>We hold your privacy in high regard and do not sell, trade, or rent your personal identification information to others. We may share generic aggregated demographic information not linked to any personal identification information with our business partners, trusted affiliates, and advertisers for the purposes outlined above. Your data may be shared with:</p>
              <div className="row mt-4">
                  <div className="col-md-4 mb-3">
                      <div className="text-center p-3 h-100">
                          <div className="policy-icon-bg mx-auto mb-3"><i className="fas fa-truck"></i></div>
                          <h6 className="fw-bold">Delivery Partners</h6>
                          <p className="small text-muted">To fulfill your orders efficiently.</p>
                      </div>
                  </div>
                   <div className="col-md-4 mb-3">
                      <div className="text-center p-3 h-100">
                           <div className="policy-icon-bg mx-auto mb-3"><i className="fas fa-credit-card"></i></div>
                          <h6 className="fw-bold">Service Providers</h6>
                          <p className="small text-muted">For services like payment processing and data analytics.</p>
                      </div>
                  </div>
                   <div className="col-md-4 mb-3">
                      <div className="text-center p-3 h-100">
                           <div className="policy-icon-bg mx-auto mb-3"><i className="fas fa-gavel"></i></div>
                          <h6 className="fw-bold">Legal Compliance</h6>
                          <p className="small text-muted">If required by law or to protect our rights.</p>
                      </div>
                  </div>
              </div>

              {/* Section: Data Security */}
              <h2 className="h4 fw-bold mt-5 mb-4">
                <i className="fas fa-shield-alt me-3 section-icon"></i>4. Data Security
              </h2>
              <p>
                We are committed to protecting your information. We adopt appropriate data collection, storage, and processing practices and security measures—including SSL encryption and secure server hosting—to protect against unauthorized access, alteration, disclosure, or destruction of your personal information, username, password, transaction information, and data stored on our Site. However, no internet transmission is 100% secure, and we cannot guarantee absolute security.
              </p>

              {/* Section: Your Rights */}
              <h2 className="h4 fw-bold mt-5 mb-4">
                <i className="fas fa-user-edit me-3 section-icon"></i>5. Your Rights & Choices
              </h2>
               <div className="card border-0 bg-light mb-4">
                  <div className="card-body">
                    <p className="mb-3">You have full control over your personal data. Your rights include:</p>
                    <ul className="list-group list-group-flush">
                        <li className="list-group-item"><i className="fas fa-check-circle me-2"></i><strong>Right to Access:</strong> You can request a copy of the personal data we hold about you.</li>
                        <li className="list-group-item"><i className="fas fa-check-circle me-2"></i><strong>Right to Rectification:</strong> You can ask us to correct or complete any inaccurate or incomplete data.</li>
                        <li className="list-group-item"><i className="fas fa-check-circle me-2"></i><strong>Right to Erasure ('Right to be Forgotten'):</strong> You can request the deletion of your account and associated personal data.</li>
                        <li className="list-group-item"><i className="fas fa-check-circle me-2"></i><strong>Right to Withdraw Consent:</strong> You can revoke Facebook login access and other permissions at any time through your Facebook account settings.</li>
                    </ul>
                  </div>
              </div>

              {/* Section: Changes to This Policy */}
              <h2 className="h4 fw-bold mt-5 mb-4">
                <i className="fas fa-sync-alt me-3 section-icon"></i>6. Changes to This Privacy Policy
              </h2>
              <p>
                We have the discretion to update this privacy policy at any time. When we do, we will revise the updated date at the bottom of this page. We encourage Users to frequently check this page for any changes to stay informed about how we are helping to protect the personal information we collect.
              </p>

              {/* Section: Contact Us */}
              <h2 className="h4 fw-bold mt-5 mb-4">
                <i className="fas fa-envelope me-3 section-icon"></i>7. Contact Us
              </h2>
              <p>
                If you have any questions about this Privacy Policy, the practices of this site, or your dealings with this site, please contact our Data Protection Officer at:
              </p>
              <div className="mt-3 p-4 rounded-3 text-center contact-box">
                  <strong className="d-block">Email Support</strong>
                  <a href="mailto:Support@booze247.co.uk" className="text-decoration-none gradient-text h5">Support@booze247.co.uk</a>
              </div>

              <div className="mt-5 text-center text-muted">
                  <p className="small">Last updated: June 30, 2025</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// The main App component to render the Privacy Policy page
export default function App() {
  return (
    <PrivacyPolicy />
  );
}
